// TODO: add unit tests for these utils
export function parseCSV(rawCSV: string): Record<string, string>[] {
  const [headers, ...rows] = rawCSV.split("\n").map((row) => row.replaceAll("\r", "").split(","));

  const result = rows.map((row) =>
    row.reduce(
      (acc, value, index) => {
        acc[headers[index]] = value;
        return acc;
      },
      {} as Record<string, string>,
    ),
  );
  return result;
}

export function convertToCSV(
  headers: string[],
  data: Record<string, string>[],
): string {
  const escapeCSVValue = (value: string): string => {
    if (value.includes(",") || value.includes('"') || value.includes("\n")) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  };

  const rows = data.map((row) =>
    Object.keys(row)
      .map((key) => escapeCSVValue(row[key] || ""))
      .join(","),
  );

  return [headers.join(","), ...rows].join("\n");
}

export function downloadCSV(filename: string, csvContent: string) {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", `${filename}.csv`);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
